<template>
  <div
    class="img-wrapp"
    v-if="imgLink"
    :class="{'canshow':canRevise}"
    :draggable="canDrag&&canRevise"
  >
    <div class="img" @click="showImgViewer" :style="{'backgroundImage':'url('+imgLink+')'}"></div>
    <div
      v-if="showAsk"
      @click="showTips"
      class="ask-wrapp animate"
      :style="{'--bgcolor':bgColor}"
      :class="{'hide':!ask}"
    >
      <i v-if="!ask&&canRevise" class="icon-pencil" style="margin-right:10px"></i>
      {{ask?ask:canRevise?'添加调修要求':''}}
    </div>
    <div class="check" v-if="isSelect&&canRevise">
      <input
        v-model="localSelected"
        type="checkbox"
        class="checkInput animate"
        @change="bindClick('check')"
      />
    </div>
    <div class="delete" v-if="isDelete&&canRevise">
      <button @click="bindClick('delete')">
        <i class="icon-delete"></i>
      </button>
    </div>
    <div class="delete" v-if="isClose&&canRevise">
      <button @click="bindClick('close')">
        <i class="icon-cross"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgLink: String,
    selected: Boolean,
    ask: String,
    isSelect: Boolean,
    isDelete: Boolean,
    isClose: Boolean,
    isDrag: Boolean,
    imgId: String,
    bgColor: {
      type: String,
      default: "rgba(0,0,0,.8)"
    },
    info: Object,
    showAsk: {
      type: Boolean,
      default: true
    }
  },
  data() {
    let localSelected = this.selected;
    return {
      localSelected: localSelected,
      canDrag: false
    };
  },
  methods: {
    showImgViewer() {
      let _this = this;
      this.$photoViewer({
        id: _this.imgId,
        onhide: function() {
          // _this.$forceUpdate();
        }
      });
    },
    bindClick(type) {
      // 禁止操作
      if (!this.canRevise) return;
      let _this = this;
      if (type == "check" || type == "close") {
        this.$emit("bindClick", type, {
          info: _this.info,
          data: _this.localSelected
        });
      } else if (type == "delete") {
        this.$emit("bindClick", type, {
          info: _this.info
        });
      }
    },
    showTips(e) {
      // 禁止操作
      if (!this.canRevise) return;
      let _this = this;
      _this.canDrag = false;
      this.$my_message.show(
        {
          type: "remark",
          title: _this.ask == "" ? "添加调修要求" : "修改调修要求",
          data: _this.ask,
          success: function(data) {
            // _this.$emit("bindClick", "ask", {
            //   info: _this.info.index,
            //   data: data
            // });

            _this.$store.commit("setImgAsk", {
              id: _this.imgId,
              data: data
            });
          },
          close: function() {
            if (_this.isDrag) {
              _this.canDrag = true;
            }
          }
        },
        e
      );
    }
  },
  computed: {
    canRevise() {
      return this.$store.getters.getCanRevise;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.canDrag = this.isDrag;
    });
  },
  watch: {
    selected(n, l) {
      this.localSelected = n;
    }
  }
};
</script>

<style lang='scss' scoped>
.img-wrapp {
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 4px;
  overflow: hidden;
  .img {
    background: no-repeat center;
    background-size: cover;
    width: 100%;
    height: 100%;
    background-color: #ddd;
  }
  .hide {
    opacity: 0;
  }
  .ask-wrapp {
    position: absolute;
    width: 100%;
    height: 32px;
    line-height: 32px;
    bottom: 0;
    left: 0;
    padding: 0 6px;
    color: #fff;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.8);
  }

  .check,
  .delete {
    position: absolute;
    width: 22px;
    height: 22px;
    border-radius: 5px;
    overflow: hidden;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
}
.delete {
  button {
    width: 22px;
    height: 22px;
    background: rgba(211, 49, 20, 1);
    border: 1px solid rgba(232, 71, 43, 1);
    border-radius: 5px 5px 5px 5px;
    color: #fff;
    padding: 0;
    margin: 0;
    font-size: 13px;
    line-height: 22px;
    text-align: center;
    cursor: pointer;
  }
}

.canshow:hover {
  .ask-wrapp {
    background-color: var(--bgcolor);
  }
  .hide {
    opacity: 1;
  }
}
</style>